module.exports = __webpack_public_path__ + "static/dash-tarjeta-5cc2408c765c994427ae4ea84e2f7cdf.jpg";